<template>
	<div v-if="data">
		<p class="font-bold mr-4 mb-2" v-if="data.sessiontyperoom_name">{{ data.sessiontyperoom_name }}</p>
		<div class="float-left mr-4"><b-icon icon="person-fill"></b-icon> {{ data.sessiontyperoom_capacity }}</div>
		<div class="float-left"><b-icon icon="door-closed-fill"></b-icon> {{ data.room_ids && data.room_ids.length ? data.room_ids.length : "0" }} linked {{ data.room_ids && data.room_ids.length === 1 ? "room" : "rooms" }}</div>
	</div>
</template>

<script>
export default {
	props: ["data", "swipedLeftItem"],
	mounted() {
		console.log("data", this.data);
	},
};
</script>
